import { getPaymentStrategy, loadStripe } from '@clickadilla/components/PaymentStrategies';
import saveGateway from '@/iframe/utils/saveGateway';
import createIframe from './createIframe';
import createJsApi from './createJsApi';
import { saveAffiliateCode, getSavedAffiliateCode } from './saveAffiliateCode';
import processApiUrl from './processApiUrl';

loadStripe();
saveAffiliateCode();

window.vastServiceOrderWidget = ({
  mountTargetSelector,
  apiUrl,
  apiToken,
  language = 'en',
  currency = 'USD',
  title = '',
  theme = 'light',
  coupons = [],
  customStyles = '',
  skin = 'default',
  authToken = '',
  isCabinet = false,
  availableNetworks: availableNetworksIds = [],
  availableServices: availableServicesIds = null,
  defaultMode = 'custom', // custom | budget
  defaultCustomSettingsView = 'horizontal', // horizontal | vertical
  iframeUrl = '',
  googleClientId = '',
}) => {
  // eslint-disable-next-line
  apiUrl = processApiUrl(apiUrl)

  const iframeApi = createIframe({
    mountTargetSelector,
    apiUrl,
    iframeUrl,
  });

  iframeApi.onCreated(() => {
    iframeApi.init({
      apiUrl,
      apiToken,
      googleClientId,
      language,
      currency,
      title,
      theme,
      skin,
      coupons,
      customStyles,
      isCabinet: isCabinet || !!authToken,
      availableNetworksIds,
      availableServicesIds,
      defaultMode,
      defaultCustomSettingsView,

      affiliateCode: getSavedAffiliateCode(),
    });
  });

  iframeApi.onPaymentData(({
    paymentData,
    strategy,
  }) => {
    const method = getPaymentStrategy(strategy);

    if (method) {
      method(paymentData);
      saveGateway();
    }
  });

  const jsApi = createJsApi(iframeApi);

  window.vastServiceOrderWidget.instances.push(jsApi);

  return jsApi;
};

window.vastServiceOrderWidget.multiple = true;

window.vastServiceOrderWidget.instances = [];
window.vastServiceOrderWidget.build_hash = process.env.VUE_APP_BUILD_HASH;
window.vastServiceOrderWidget.instances.destroy = () => {
  window.vastServiceOrderWidget.instances.forEach(
    (widget) => widget.destroy(),
  );
};
